import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, mergeMap } from 'rxjs/operators';
import { getToken } from 'src/app/state/user.selectors';
import { environment } from 'src/environments/environment';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);

  // Skip auth endpoint - don't add token to login requests
  const authUrl = `${environment.apiUrl.substring(0, environment.apiUrl.length - 3)}/stb/api-token-auth/`;

  if (req.url === authUrl) {
    return next(req);
  }

  return store.select(getToken).pipe(
    first(),
    mergeMap((token) => {
      const authReq = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;
      return next(authReq);
    })
  );
};
